let desktopWidgetPanier = document.getElementById('desktop-widget-panier');
let mobileWidgetPanier = document.getElementById('mobile-widget-panier');
const widgetPanier = document.createElement('div');
widgetPanier.id = 'widget-panier';

function debounce(callback, delay){
    var timer;
    return function(){
        var args = arguments;
        var context = this;
        clearTimeout(timer);
        timer = setTimeout(function(){
            callback.apply(context, args);
        }, delay)
    }
}

const checkWindowSize = () => {
    const windowW = window.innerWidth;
    if(windowW <= 1070){
        desktopWidgetPanier.innerHTML = '';
        mobileWidgetPanier.appendChild(widgetPanier);
    } else {
        mobileWidgetPanier.innerHTML = '';
        desktopWidgetPanier.appendChild(widgetPanier);
    }
}

window.addEventListener('resize', debounce(checkWindowSize, 300));
checkWindowSize();